export default __webpack_public_path__ + "static/ppma-265515d4b65b063637584229bcc696fb.png";